const SITE_URL = 'https://coursepress.lnu.se'
const PATH_PREFIX = '/kurser/webbprogrammering-pa-klientsidan-ht24'

const config = {
  gatsby: {
    pathPrefix: PATH_PREFIX,
    siteUrl: SITE_URL,
    gaTrackingId: null
  },
  header: {
    logoLink: '/',
    title: 'logo-wordmark-sv.png',
    courseName: 'Webbprogrammering på klientsidan (1DV025)',
    links: [
      { text: 'GitLab', link: 'https://gitlab.lnu.se/1dv025' },
      { text: 'Zoom', link: `${SITE_URL}${PATH_PREFIX}/zoom` },
      { text: 'Moodle', link: 'https://moodle.lnu.se/course/view.php?id=63358'},
      { text: 'YouTube', link: 'https://www.youtube.com/cslnu' },
      { text: 'Schema', link: 'https://cloud.timeedit.net/lnu/web/schema2/ri1YqX0QQYwZ5ZQv550X57c5ycY95Z7Y66Q5595Q6671Z0Q1yhb0ncdQnwcZpmc.html#'}
    ]
  },
  sidebar: {
    frontline: false,
    ignoreIndex: true,
    startCollapsed: true
  },
  siteMetadata: {
    title: 'Linnéuniversitetet',
    courseCode: '1dv025',
    language: "sv",
    description: 'Documentation built with mdx. Powering learn.hasura.io ',
    ogImage: null
  }
}

module.exports = config
